<template>
  <v-col cols="12">
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card>
      <v-card-title>Hébergements</v-card-title>

      <v-card-text>
        <div class="global-actions">
          <router-link :to="{ name: 'rentingCreate' }">
            <v-btn
              small
              color="primary"
              class="mt-5"
            >
              Ajouter une page hébergement
            </v-btn>
          </router-link>
        </div>
      </v-card-text>

      <div class="clear"></div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-uppercase">
                Nom
              </th>
              <th class="text-center text-uppercase">
                Type
              </th>
              <th class="text-center text-uppercase">
                Position
              </th>
              <th class="text-center text-uppercase">
                Menu
              </th>
              <th class="text-center text-uppercase">
                Etat
              </th>
              <th class="text-center text-uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(renting, rentingIndex) in rentings"
              :key="'e' + rentingIndex"
            >
              <td class="font-weight-bold">
                {{ renting.name }}
              </td>
              <td class="text-center">
                {{ renting.type === '3' ? 'Location' : 'Emplacement' }}
              </td>
              <td class="text-center">
                {{ renting.position ? renting.position : '-' }}
              </td>
              <td class="text-center">
                <v-chip
                  v-if="renting.inMenu"
                  color="success"
                  text-color="white"
                  small
                >
                  Oui
                </v-chip>
                <v-chip
                  v-if="!renting.inMenu"
                  color="error"
                  text-color="white"
                  small
                >
                  Non
                </v-chip>
              </td>
              <td class="text-center">
                <v-chip
                  v-if="renting.enabled"
                  color="success"
                  text-color="white"
                  small
                >
                  Activée
                </v-chip>
                <v-chip
                  v-if="!renting.enabled"
                  color="error"
                  text-color="white"
                  small
                >
                  Désactivée
                </v-chip>
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      :to="{ name: 'rentingDetails', params: { rentingId: renting.id }}"
                    >
                      <v-icon dark>
                        {{ icons.mdiEye }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Consulter</span>
                </v-tooltip>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      color="error"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      @click="openDeleteRentingDialog(renting)"
                    >
                      <v-icon dark>
                        {{ icons.mdiTrashCan }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!rentings.length">
            <tr>
              <td>
                <span v-if="loading === false">Aucun éléments.</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <DeleteRentingDialog
        :key="Date.now()"
        :delete-renting-dialog-state="deleteRentingDialogState"
        :renting="rentingToDelete"
        @closeDeleteRentingDialog="closeDeleteRentingDialog($event)"
      ></DeleteRentingDialog>
    </v-card>
  </v-col>
</template>

<script>
import { mdiPlay, mdiPen, mdiEye, mdiTrashCan } from '@mdi/js'
import Vue from 'vue'
import DeleteRentingDialog from '@/components/Dialog/RentingDialog/DeleteRentingDialog'
import config from '../../config'
import Loader from '@/components/Common/Loader'

export default {
  components: {
    DeleteRentingDialog,
    Loader
  },
  data: () => ({
    rentings: [],
    rentingToDelete: null,
    deleteRentingDialogState: false,
    loading: false,
    icons: {
      mdiPlay,
      mdiPen,
      mdiEye,
      mdiTrashCan
    }
  }),
  created () {
    this.getRentings()
  },
  methods: {
    getRentings () {
      this.loading = true

      Vue.prototype.$http
        .get(config.apiUrl + '/api/accommodation/rentings', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            const data = response.data

            if (data) {
              this.rentings = data
            }
          }

          this.loading = false
        })
        .catch(e => {
          const response = e.response

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
        })
    },
    openDeleteRentingDialog (renting) {
      this.deleteRentingDialogState = true
      this.rentingToDelete = renting
    },
    closeDeleteRentingDialog (deleteState) {
      if (deleteState === true) {
        this.rentings = this.rentings.filter(element => element.id !== this.rentingToDelete.id)
      }

      this.deleteRentingDialogState = false
    },
    resolveAttrValue (data, attr) {
      console.log(data)
      const translations = data.translations

      if (translations.fr) {
        return translations.fr[attr]
      }

      return '-'
    }
  }
}
</script>

